import { State } from "../../types";

export type SetScrollToBlockAction = Readonly<{
  blockId: string;
  type: "SET SCROLL TO BLOCK";
}>;

export const setScrollToBlock = (state: State, action: SetScrollToBlockAction): State => {
  if (state.scrollToBlock === action.blockId) {
    return state;
  }
  return {
    ...state,
    scrollToBlock: action.blockId,
  };
};
